import { useMemo } from "react";

export default function EditedBy({params}){
    const centerStyle = "center_perfect";

    const updatedBy = useMemo(() => {
        const {value} = params
        if(!value){
            return "-"
        }
        return value
    },[params])

    return (
        <span
            className={`hide-scrollbar ${centerStyle}`}
            style={{ height: "100%", overflowY: "auto" }}
        >
            {updatedBy}
        </span>
    )
}